export default __webpack_public_path__ + "static/media/felix.0e82de43.jpg";